export const toJSONApiPayload = <D = Record<string, any>>(data: D) => ({
  data: {
    attributes: {
      ...data,
    },
  },
});
